




























































































































































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'
import BackButton from './BackButton'

import ShoppingCartStep from './ShoppingCartStep'
import PurchaseStep from './PurchaseStep'
import SubmitOffersStep from './SubmitOffersStep'

import ShoppingCartSummary from '@ui/EventFeed/ShoppingCartSummary'

import RemoveFromCartTriggerModal from '@triggers/CheckoutWizard/RemoveFromCartTriggerModal'
import SubmitOffersTriggerModal from '@triggers/CheckoutWizard/SubmitOffersTriggerModal'
import UpdateOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPriceTriggerModal'
import UpdateOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPayoutTriggerModal'
import UpdateQuantityTriggerModal from '@triggers/CheckoutWizard/UpdateQuantityTriggerModal'
import UpdateLineItemDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateLineItemDiscountTriggerModal'

import Modal from '@/components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: "CheckoutWizard"

  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'event_schedules/:scheduleId/shopping_cart'
      fetch: false

    draftOffers:
      resourceName: 'offers'
      slug: 'event_schedules/:scheduleId/offers' # scope this to brand_rep (brand_reps/:brandRepId/offers)
      infinityScroll: false
      params:
        scope: 'draft'
        per_page: 1000
      fetch: false

    activations:
      resourceName: 'activation'
      slug: 'brand_reps/:brandRepId/activations'
      fetch: false

  vue:
    props: ['selectedSchedule']
    mixins: [WizardService.wizard()]

    components: {
      RequestButton,
      BackButton,
      ShoppingCartStep,
      PurchaseStep,
      SubmitOffersStep,
      RemoveFromCartTriggerModal,
      SubmitOffersTriggerModal,
      UpdateOriginalPriceTriggerModal,
      UpdateOriginalPayoutTriggerModal,
      UpdateQuantityTriggerModal,
      UpdateLineItemDiscountTriggerModal,
      ShoppingCartSummary,
      Modal,
      LoadingIndicator
    }

    data: ->
      agreeToTOS: false

      purchaseProgressModal:
        show: false

    mounted: ->
      @fetch('cart') if @schedule

    computed:
      schedule: -> @selectedSchedule || @getAppSession('selectedEventSchedule')
      scheduleId: -> @schedule?.id
      brandRepId: -> @$route.params.brandRepId
      lineItems: -> @cart?.line_items or []
      savedLineItems: -> @cart?.saved_line_items or []
      purchaseDiscounts: -> @cart?.purchase_discounts or []
      cartIsEmpty: -> !@lineItems.length
      cartHasSavedLineItems: -> !!@savedLineItems.length
      allLineItemsCount: -> @lineItems.length + @savedLineItems.length
      draftOffersCount: -> @draftOffers?.length or 0

      draftOffersTotalReach: ->
        reach = 0
        return reach if not @draftOffers
        @draftOffers.forEach((offer) ->
          reach += offer.ctx.event.reach
        )
        reach

      draftOffersTotalVirtualReach: ->
        return 100

      draftOffersTotalPrice: ->
        price = 0
        return price if not @draftOffers
        @draftOffers.forEach((offer) ->
          price += offer.buyer_final_price_in_dollars
        )
        price

      isLastStep: ->
        return @activeStep.idx + 1 is @steps.length
      stepIsShoppingCart: ->
        return @activeStep?.name is 'shopping_cart'
      stepIsPurchase: ->
        return @activeStep?.name is 'purchase'
      stepIsSubmitOffers: ->
        return @activeStep?.name is 'submit_offers'
      canGoBackward: ->
        return false if @stepIsSubmitOffers
        return @activeStep.idx - 1 >= 0
      canGoForward: ->
        return false if !@lineItems?.length
        return @activeStep.idx + 1 < @steps.length

      canPurchase: -> @agreeToTOS && !@cartIsEmpty
      canSubmit: ->
        return false if not @draftOffers
        appliedActivations = @draftOffers.filter((offer) -> offer.applied_activation_names.length)
        return appliedActivations.length is @draftOffers.length

      showShoppingCartSummary: -> @stepIsShoppingCart
      showPuchaseSummary: -> @stepIsPurchase
      showSubmitOffersSummary: -> @stepIsSubmitOffers

    methods:
      hiPurchaseTrigger: ->
        payload = {}
        @triggerResource 'cart', 'purchase', payload
        @purchaseProgressModal.show = true
      onCartPurchase: ->
        @fetch('cart')

      hiPurchaseDone: ->
        @purchaseProgressModal.show = false
        if @currentMemberIsSuperUser()
          @next({ skipSave: true })
        else
          @$router.push({ name: 'EventScheduleListPage' })

      removeFromCartTrigger: (lineItem) ->
        payload =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.checkoutWizardRemoveFromCartTrigger.fire(payload, modalOptions)
      onCartRemoveFromCart: ->
        @fetch('cart')
        @$refs.checkoutWizardRemoveFromCartTrigger.close()

      hiSaveForLaterTrigger: (lineItem) ->
        payload =
          event_id: @ctxEvent(lineItem).id
        @triggerResource 'cart', 'save_for_later', payload
      onCartSaveForLater: ->
        @fetch('cart')

      hiMoveToCartTrigger: (lineItem) ->
        payload =
          event_id: @ctxEvent(lineItem).id
        @triggerResource 'cart', 'move_to_cart', payload
      onCartMoveToCart: ->
        @fetch('cart')

      submitOffersTrigger: ->
        payload =
          offer_ids: @draftOffers.map((o) -> o.id)
        @$refs.submitOffersTrigger.fire(payload)
      onDraftOffersSubmitOffers: ->
        @fetch('draftOffers')
        @$refs.submitOffersTrigger.close()

        if @currentMemberIsSuperUser()
          @$router.back()
        else
          @$router.push({ name: 'EventScheduleListPage' })

      updateOriginalPriceTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateOriginalPrice: ->
        @fetch('cart')
        @$refs.updateOriginalPriceTrigger.close()

      updateOriginalPayoutTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateOriginalPayout: ->
        @fetch('cart')
        @$refs.updateOriginalPayoutTrigger.close()

      updateQuantityTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateQuantityTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateQuantity: ->
        @fetch('cart')
        @$refs.updateQuantityTrigger.close()

      updateLineItemDiscountTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateLineItemDiscount: ->
        @fetch('cart')
        @$refs.updateLineItemDiscountTrigger.close()

      hiApplyActivationTrigger: (payload) ->
        @triggerResource 'draftOffers', 'apply_activation', payload
      onDraftOffersApplyActivation: ->
        @fetch('draftOffers')

      hiRemovePurchaseDiscountTrigger: (lineItem) ->
        payload =
          line_item_id: lineItem.id
        @triggerResource 'cart', 'remove_purchase_discount', payload
      onCartRemovePurchaseDiscount: ->
        @fetch('cart')

    watch:
      schedule: (sch) ->
        @fetch('cart') if sch

export default VueOptions.vue settings

# Scenarios
# Step ShoppingCart:
#   One item in cart (Next is enabled)
#   Save to Cart
#   No Items in Cart (Next is disabled)
#
# Step Puchase:
#   TOS unchecked (Purchase is disabled)
#   TOS checked (Purchase is enabled)
#
# Step Submit Offers:
#   Cart is not empty (Back navs you to PurchasesStep)
#   Cart is empty but has saved items (Back navs you to ShoppingCartStep)
#   Cart is empty and no saved items (No Back button)
